
import { defineComponent, ref } from "vue";
import UPLOADING from "@/components/uploading/uploading.vue";
import codeEditor from '@/components/codeEditor/codeEditor.vue';
import { ElLoading ,ElMessage } from "element-plus";
export default defineComponent({
    setup() {
        const parent = ref();
        
        const up = async () => {
            let { child, isEmpty, stop } = parent.value.parent();
            if(!isEmpty) return ElMessage.error('请选择需要上传的图片');
            const loading = ElLoading.service({
                lock: true,
                text: "上传中....",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 实现上传
            await child();
            //上传完成
            stop();
            loading.close();
            
        };

        
        const call=ref([
            {
                name:"title",
                class:"String",
                default:"上传图片",
                effect:"顶部标题",
                detail:"非必填项"
            },
            {
                name:"count",
                class:"Number",
                default:"0",
                effect:"可一次性同时上传几张",
                detail:"如果为0，张数无限制。非必填项"
            },
            {
                name:"value",
                class:"Object",
                default:"{}",
                effect:"另外传给后端的参数",
                detail:"非必填项"
            }
        ]);
        const property=ref([
           
            {
                name:"child",
                class:"Function",
                effect:"触发axios上传接口",
                detail:"通过调用child()实现上传接口的调用"
            },
             {
                name:"isEmpty",
                class:"Boolean",
                effect:"目前是否选择了图片",
                detail:"返回false代表用户没有选择图片"
            },
             {
                name:"stop",
                class:"Function",
                effect:"上传完成需要执行的函数",
                detail:"代表上传已经成功"
            }
        ]);
        return {
            up,
            parent,
            call,
            property
        };
    },
    components: { UPLOADING ,codeEditor},
});
